import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import getLabel from '../../utilities/label.js'
import TitleBar from '../TitleBar'

export default class Sponsors extends Component {
  constructor(props) {
    super(props)
    const refreshButton = '<i class=\'fa fa-refresh\'></i>'
    const backButton = '<i class=\'fa fa-arrow-left\'></i> ' + getLabel('back_button')
    this.state = {
      sponsors: this.props.sponsors,
      refreshButton: refreshButton,
      backButton: backButton
    }
    this.refresh = this.refresh.bind(this)
    this.props.setActiveTab('sponsors')
    window.trackPage('SponsorsScreen')
  }

  refresh() {
    const refreshButton = '<i class=\'fa fa-refresh fa-spin\'></i>'
    this.setState({ refreshButton: refreshButton })
    this.props.getResource({
      key: 'sponsors',
      update: true,
      callback: () => {
        this.setState({
          refreshButton: '<i class=\'fa fa-refresh\'></i>'
        })
      }
    })
  }

  render() {
    var sponsorRow = null
    var lastSponsorType = null
    var hr = null
    var sponsors = []
    _.each(this.props.sponsors.sponsors, function(sponsor){
      if(!sponsor.is_hidden){
        if(sponsor.sponsor_type_name !== lastSponsorType){
          sponsors.push(
            <div className='sponsor-row' key={ sponsor.sponsor_type_display_rank }>
              <p className='subheader centered'>{ sponsor.sponsor_type_name }</p>
            </div>
          )
          lastSponsorType = sponsor.sponsor_type_name
          hr = (null)
        } else {
          hr = (<hr style={{margin: '1rem 0'}}/>)
        }
        if(sponsor.logo){
          sponsorRow = (<img src={sponsor.logo} alt={sponsor.name} title={sponsor.name} />)
        } else {
          sponsorRow = (<p className="no-logo">{sponsor.name}</p>)
        }
        sponsors.push(
          <Link to={'/sponsor/' + sponsor.id} key={ sponsor.id } >
            <div className='sponsor-row'>
              {hr}
              {sponsorRow}
            </div>
          </Link>
        )
      }
    })
    return (
      <div className='sponsors-page'>
        <TitleBar
          title={ getLabel({ key: 'sponsor', plural: sponsors.length }) }
          leftButtonLabel={ this.state.backButton }
          leftButtonAction={ () => window.history.back() }
          rightButtonLabel={ this.state.refreshButton }
          rightButtonAction={ this.refresh } />
        { sponsors }
        <pre className="debug-json">{JSON.stringify(this.props.sponsors, false, 2)}</pre>
      </div>
    )
  }
}
